import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { getAcademicYears } from "../services/school/academicYear/getAcademicYears";
import { getCurrentAcademicYear } from "../services/school/academicYear/getCurrentAcademicYear";

export const useGetCurrentAcademicYearQuery = () =>
  useQuery(
    ["current-academic-year", "current-academic-year"],
    () => getCurrentAcademicYear()
  );